import React from 'react';
import { useFormField, FieldError } from '../../core';
import { CheckGroupItem } from '@/ui-kit';
import './Checkbox.scss';

type CheckboxProps = {
  label: string;
  name: string;
  size?: React.ComponentProps<typeof CheckGroupItem>['scale'];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
};

export const Checkbox: React.FC<CheckboxProps> = React.memo(
  ({ label, size = 'medium', ...props }) => {
    const [field, , helpers] = useFormField(props);
    const fieldValueRef = React.useRef(field.value);

    const { onChange: formikOnChange, ...fieldProps } = field;

    React.useEffect(() => {
      if (
        typeof fieldValueRef.current === 'boolean' &&
        field.value === undefined
      ) {
        helpers.setValue(fieldValueRef.current);
      } else {
        fieldValueRef.current = field.value;
      }
    }, [field.value, helpers]);

    return (
      <div className="checkbox__group">
        <CheckGroupItem
          scale={size}
          group={field.name}
          id={field.name}
          label={label}
          checked={field.value === true}
          disabled={props.disabled}
          indeterminate={false}
          onChange={e => {
            props.onChange?.(e);
            formikOnChange(e);
          }}
          {...fieldProps}
          value={field.value as string | number | readonly string[] | undefined}
        />
        <FieldError name={props.name} />
      </div>
    );
  },
);
